import {
  TableContainer,
  Paper,
} from '@mui/material';

const TemplateNotFound = () => {
  return (
    <TableContainer
    sx={{
      marginTop: '48px',
      borderRadius: '15px',
      marginBottom: '16px',
      padding: '32px',
      display: 'flex',
      justifyContent: 'center',
    }}
    component={Paper}
  >
    <p className="text-red-700">No Statement type was found. Please contact support</p>
  </TableContainer>
  )
}

export default TemplateNotFound;